import { REQUIRED_EVENT_FIELDS } from "../constants/analytics.es.js";
import { logger } from "../../utils/logger.es.js";
const checkRequiredFields = (payload) => {
  Object.values(REQUIRED_EVENT_FIELDS).forEach((field) => {
    if (!payload.properties[field]) {
      logger.error(
        `Missing required field on analytics call: ${field}`,
        payload.properties
      );
    }
  });
};
const analyticsDebug = () => {
  return {
    identify: ({ payload }) => {
      var _a;
      (_a = logger) == null ? void 0 : _a.info("ANALYTICS :: debug :: identify", payload);
    },
    /* Everything else below this is optional depending on your plugin requirements */
    initialize: ({ config }) => {
      var _a;
      (_a = logger) == null ? void 0 : _a.info("ANALYTICS :: debug :: initialize", config);
    },
    loaded: () => true,
    /* All plugins require a name */
    name: "debug-plugin",
    page: ({ payload }) => {
      var _a, _b;
      checkRequiredFields(payload);
      (_b = logger) == null ? void 0 : _b.info(
        `ANALYTICS :: debug :: page - ${(_a = payload == null ? void 0 : payload.properties) == null ? void 0 : _a.page_name} - Page Loaded`,
        payload
      );
    },
    track: ({ payload }) => {
      var _a, _b;
      checkRequiredFields(payload);
      (_b = logger) == null ? void 0 : _b.info(
        `ANALYTICS :: debug :: track - ${(_a = payload == null ? void 0 : payload.properties) == null ? void 0 : _a.page_name} - ${payload == null ? void 0 : payload.event}`,
        payload
      );
    }
  };
};
export {
  analyticsDebug
};
